export default __webpack_public_path__ + "static/media/AppStore.542e728d.png";